export const formatDate = (
  date,
  outputFormat = "mm-dd-yyyy",
  stringInputFormat = "yyyy-mm-dd"
) => {
  let formatted = outputFormat;
  let day, year, month;

  if (typeof date === "string") {
    switch (stringInputFormat) {
      case "yyyy-mm-dd":
        [year, month, day] = date.split("-");
        break;
      case "dd-mm-yyyy":
        [day, month, year] = date.split("-");
        break;
      case "mm-dd-yyyy":
        [month, day, year] = date.split("-");
        break;
      default:
        return;
    }
  } else {
    day = date.getDate();
    month = date.getMonth() + 1;
    year = date.getFullYear();
  }

  formatted = formatted.replace("yyyy", year);
  formatted = formatted.replace("dd", day.toString().padStart(2, "0"));
  formatted = formatted.replace("mm", month.toString().padStart(2, "0"));

  return formatted;
};
